/*
 * Textbox with label
 */
import React from "react";

import TxtBox from "components/Custom/TxtBox";

const TxtRow = ({
  id,
  label,
  type = "text",
  required = false,
  defaultValue = "",
  disabled = false,
}) => {
  return (
    <>
      <label className="required">
        {label}
        {required && <span className="red">{"*"}</span>}
      </label>
      <TxtBox
        id={id}
        type={type}
        placeholder={label}
        defaultValue={defaultValue}
        disabled={disabled}
      />
    </>
  );
};

export default TxtRow;
